import { call, put } from 'redux-saga/effects';
import { getFixedPricePayments, updateFixedPricePayment, deleteFixedPricePayment, clearFixedPricePayments, getUnconfiguredFixedPriceEntities } from '../requests/fixedPricePayments';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetFixedPricePayments(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(getFixedPricePayments);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback({ payments: [] });
    }
}

export function* handleGetUnconfiguredFixedPriceEntities(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(getUnconfiguredFixedPriceEntities);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback({ entities: [] });
    }
}

export function* handleUpdateFixedPricePayment(action) {
    try {
        const { parentType, parentId, paymentId, body, callback } = action.payload;
        const response = yield call(updateFixedPricePayment, parentType, parentId, paymentId, body);
        yield put(showAlert({ severity: 'success', message: 'Payment updated' }));
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) action.payload.callback(null);
    }
}

export function* handleDeleteFixedPricePayment(action) {
    try {
        const { parentType, parentId, paymentId, callback } = action.payload;
        yield call(deleteFixedPricePayment, parentType, parentId, paymentId);
        yield put(showAlert({ severity: 'success', message: 'Payment deleted' }));
        if (callback) callback(true);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) action.payload.callback(false);
    }
}

export function* handleClearFixedPricePayments(action) {
    try {
        const { parentType, parentId, callback } = action.payload;
        yield call(clearFixedPricePayments, parentType, parentId);
        yield put(showAlert({ severity: 'success', message: 'All payments cleared' }));
        if (callback) callback(true);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) action.payload.callback(false);
    }
}
